import { AfterViewInit, Directive, ElementRef, Injectable, Input } from '@angular/core';

/**
 * Aids the strategy of locating elements to be asserted on in acceptance tests by a special attribute data-tid-{name}
 * in order to reduce brittleness. This is instead of searching by class/id which change more often.
 * Usage on html elements: <button tid="submit-button" />, creates the attribute 'data-tid-submit-button'.
 */
@Injectable({ providedIn: 'root' })
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[tid]',
  standalone: true
})
export class TestIdDirective implements AfterViewInit {
  @Input() tid?: string;

  constructor(private el: ElementRef) {}

  // eslint-disable-next-line @angular-eslint/contextual-lifecycle -- used as Directive on elements, not as pure Injectable
  ngAfterViewInit(): void {
    if (!this.tid) return;
    this.el.nativeElement.setAttributeNode(document.createAttribute(`data-tid-${this.tid}`));
  }
}
